<app-frame [overlay]="false" [title]="'Map'"   (neadClose)="closeForm()" autocomplete="off" class="summaries-frame">

	<div #mapContainer id="map" style="width: 60vw; height: 80vh;"></div>

</app-frame>

